<div class="w-full relative">
    <fuse-alert
        class="mb-4"
        *ngIf="showAlertGetRegions"
        [type]="alertGetRegions.type"
        [appearance]="'outline'"
        [showIcon]="true"
        [dismissible]="false">
        {{ alertGetRegions.message }}
    </fuse-alert>
    <fuse-alert
        class="mb-4"
        *ngIf="showAlertModifyRegions"
        [type]="alertModifyRegions.type"
        [appearance]="'outline'"
        [showIcon]="true"
        [dismissible]="false">
        {{ alertModifyRegions.message }}
    </fuse-alert>
    <mat-form-field class="w-full">
        <mat-label>Región</mat-label>
        <mat-select [value]="selectedRegionId" [disabled]="disabled" (selectionChange)="onRegionChange($event.value)">
            <mat-select-trigger>
                {{ getSelectedRegionName() }}
            </mat-select-trigger>
            <mat-option [value]="0" class="bg-gray-100">Sin región</mat-option>
            <mat-option *ngFor="let region of regions" [value]="region.id">
                <div class="flex justify-between items-center w-full">
                    <span>{{ region.name }}</span>
                    <div class="flex gap-1">
                        <button mat-icon-button color="primary" matTooltip="Editar región"
                                (click)="showRegionNameForm(region)">
                            <mat-icon fontSet="material-symbols-outlined" class="mr-0">edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" matTooltip="Eliminar región"
                                (click)="deleteRegion(region.id)">
                            <mat-icon fontSet="material-symbols-outlined" class="mr-0">delete</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-option>
            <mat-option [value]="-1" class="bg-gray-100">Agregar región...</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="absolute w-full z-60" *ngIf="loader">
        <div class="flex justify-center">
            <mat-spinner [diameter]="30" class="bg-white"></mat-spinner>
        </div>
    </div>
    <div *ngIf="selectedRegionId === -1 || modifyRegion" class="absolute top-full z-50 pb-4 w-full">
        <form [formGroup]="form" class="bg-white p-4 border border-gray-300 rounded-lg">
            <mat-form-field class="w-full">
                <mat-label>Nombre de la región</mat-label>
                <input matInput type="text" formControlName="regionName"
                       placeholder="Nombre de la región" maxlength="120">
                <mat-error *ngIf="form.get('regionName').hasError('required')">
                    La región es obligatoria
                </mat-error>
                <mat-error *ngIf="form.get('regionName').hasError('maxlength')">
                    El nombre de la región no puede tener más de 150 caracteres
                </mat-error>
                <mat-error *ngIf="form.get('regionName').hasError('minlength')">
                    El nombre de la región debe tener al menos 3 caracteres
                </mat-error>
            </mat-form-field>
            <button
                mat-raised-button
                color="primary"
                class="w-full"
                [disabled]="form.invalid || loader"
                (click)="addOrUpdateRegion()">
                {{ modifyRegion ? 'Guardar cambios' : 'Agregar región' }}
            </button>
        </form>
    </div>
</div>
